module.exports = __webpack_public_path__ + "h5/img/dh21.bea7fe64.png";